import { render } from "./CardLight.vue?vue&type=template&id=7203a526&scoped=true"
import script from "./CardLight.vue?vue&type=script&lang=js"
export * from "./CardLight.vue?vue&type=script&lang=js"

import "./CardLight.vue?vue&type=style&index=0&id=7203a526&scoped=true&lang=css"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7203a526"]])

export default __exports__